import React, { useState, useEffect, useRef } from "react";
import ParticipantDetailCard from "./ParticipantDetailCard";
import ParticipantPreviewCarousel from "./ParticipantPreviewCarousel";
import JudgesList from "./JudgesList";

const NominationDisplay = ({
  competitionId,
  nominationId,
  routes,
  onBack,
  t,
  isQuadMode,
}) => {
  const [nominationData, setNominationData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentParticipantIndex, setCurrentParticipantIndex] = useState(0);
  const intervalRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      await fetchNominationData();  
    };

    fetchData();

    // console.log("Starting nomination display for nominationId:", nominationId, nominationData);
    // Устанавливаем интервал обновления данных каждые 30 секунд
    const updateInterval = setInterval(async () => {
      const updatedData = await fetchNominationData();
      // console.log("Updated data:", updatedData);
      if (updatedData && updatedData.participants.length > 0) {
        moveToNextParticipant(updatedData);
      }
    }, 15000);

    return () => {
      // console.log("Clearing intervals...");
      clearInterval(updateInterval);
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }NominationDisplay
    };
  }, [nominationId]);

  const fetchNominationData = async () => {
    try {
      const url = routes.nomination_data_template.replace(
        "NOMINATION_ID",
        nominationId
      );
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
            .content,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      setNominationData(data);
      // console.log("Fetched nomination data:", data);

      // Если текущий индекс больше количества участников, сбрасываем на 0
      if (
        data.participants.length > 0 &&
        currentParticipantIndex >= data.participants.length
      ) {
        setCurrentParticipantIndex(0);
      }

      // Возвращаем данные для использования в интервале
      return data;
    } catch (error) {
      console.error("Error fetching nomination data:", error);
      return null;
    } finally {
      setLoading(false);
    }
  };

  const moveToNextParticipant = (data) => {
    if (data && data.participants.length > 0) {
      // console.log("Moving to next participant...");
      setCurrentParticipantIndex(
        (prev) => (prev + 1) % data.participants.length
      );
    } else {
      // console.log("No participants to move to next.", nominationData);
    }
  };

  const handleParticipantSelect = (index) => {
    setCurrentParticipantIndex(index);
  };

  if (loading) {
    return (
      <div className="nomination-display-loading">
        <div className="text-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">{t.loading}</span>
          </div>
        </div>
      </div>
    );
  }

  const currentParticipant =
    nominationData.participants[currentParticipantIndex];

  return (
    <div
      className={`nomination-display ${
        isQuadMode ? "quad-mode" : "single-mode"
      }`}
    >
      {/* Заголовок с названием номинации */}
      <div className="nomination-header">
        <h2 className="nomination-title">
          {t.nomination_title.replace(
            "%{nomination}",
            `${nominationData.nomination.title}`
          )}
        </h2>
      </div>

      {(!nominationData || !nominationData.participants.length) && (
        <div className="nomination-display-empty">
          {nominationData && nominationData.judges && nominationData.judges.length > 0 ? (
            <div className={isQuadMode ? "quad-mode" : "w-100"}>
              <JudgesList judges={nominationData.judges} t={t} isQuadMode={isQuadMode} />
            </div>
          ) : (
            <p style={{ fontSize: "1.5rem", textAlign: "center" }}>{t.no_participants}</p>
          )}
        </div>
      )}

      {nominationData && nominationData.participants.length > 0 && (
        <>
          {/* Детальная карточка текущего участника */}
          <div className="participant-detail">
            <ParticipantDetailCard
              participant={currentParticipant}
              t={t}
              isQuadMode={isQuadMode}
            />
          </div>

          {/* Карусель с превью остальных участников */}
          <div className="participants-preview">
            <ParticipantPreviewCarousel
              participants={nominationData.participants}
              currentIndex={currentParticipantIndex}
              onParticipantSelect={handleParticipantSelect}
              t={t}
              isQuadMode={isQuadMode}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default NominationDisplay;
